import { axiosWrapper } from '../hooks/axios';

type TrackActionDataType = {
  action_type: string;
  action_object?: { pk: string; type: string };
  study_group?: { pk?: string };
  data?: any;
};

const trackAction = (
  data: TrackActionDataType,
  endpoint = '/api/v1/user/user_actions/',
) => {
  axiosWrapper(endpoint, 'post', data);
};

export { trackAction };
